import { PUBLIC_SITE_ORIGIN } from "@/data/page-seo";

/**
 * www 与主域共用同一份产物，但只有主域在后端 CORS/Trusted Origins 名单里，
 * 所以 www 上的访问统一换到规范域名，避免跨域请求被拒与重复内容。
 * 返回 null 表示当前主机不需要跳转。
 */
export function canonicalRedirectUrl(
  current: URL,
  canonicalOrigin: string = PUBLIC_SITE_ORIGIN,
): string | null {
  const canonical = new URL(canonicalOrigin);
  if (current.hostname !== `www.${canonical.hostname}`) return null;
  return `${canonical.origin}${current.pathname}${current.search}${current.hash}`;
}
